export default __webpack_public_path__ + "static/media/living4.4c74cb2d.jpg";